import { BusinessDetails } from './Business';

export const data: BusinessDetails[] = [
  {
    id: '9s41rp',
    name: 'Kelvin',
    address: 'Langosh',
    zipCode: '564321',
    mail: 'Jerod14@hotmail.com',
    state: 'Ohio',
    country: 'IN',
    phone: '9876521780',
    contactName: "Msr",
    contactPhone: "54385834583",
    inactive: false,
  },
  {
    id: '08m6rx',
    name: 'mohan',
    address: 'Langosh',
    zipCode: '564321',
    mail: 'Jerod14@hotmail.com',
    state: 'Ohio',
    country: 'IN',
    phone: '9876521780',
    contactName: "ssr",
    contactPhone: "834583",
    inactive: true,
  },
];

//50 us states array
export const states = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
  'Puerto Rico',
];
